import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import RealTimeLeaderboard from './components/Quiz/Quiz';
import Nav from './components/Nav';

function App() {
  return (
    <>
    <Nav />
      <Router>
        <Routes>
        <Route path="/*" element={<RealTimeLeaderboard />} />
        </Routes>
      </Router>
    </>
  );
}
export default App;